module.exports = __webpack_public_path__ + "img/image-011.4e862b8e.png";